import { Box, Stack, useTheme } from "@mui/material";

import { type NavigationVariant } from "../Insight/getNavigationVariant";

interface WrappedProgressBarProps {
  completed: number;
  total: number;
  variant: NavigationVariant;
}

export function WrappedProgressBar(props: WrappedProgressBarProps) {
  const { completed, total, variant } = props;
  const theme = useTheme();

  const progressPercentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  const colors =
    variant === "light"
      ? { track: "rgba(255, 255, 255, 0.3)", bar: theme.palette.common.white }
      : { track: "rgba(0, 0, 0, 0.2)", bar: theme.palette.common.black };

  return (
    <Stack direction="row" alignItems="center" sx={{ width: "100%" }}>
      <Box
        sx={{
          flex: 1,
          height: 6,
          backgroundColor: colors.track,
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: `${progressPercentage}%`,
            height: "100%",
            backgroundColor: colors.bar,
            borderRadius: 2,
            transition: "width 0.3s ease",
          }}
        />
      </Box>
    </Stack>
  );
}
